import { getTranslationByPartnerAccess } from '../../../../helpers/getTranslationByPartnerAccess'
import { ITranslationOptions } from '../../../../models/translationOptions'
import { TRANSLATION_KEYS, TRANSLATION_KEYS_LARGE_FORMAT } from '../translations'

export const getFieldLabelTranslation = ({
  isLargeFormatMode,
  isDistributor,
  isRetail,
}: ITranslationOptions) => {
  if (isLargeFormatMode) {
    return getTranslationByPartnerAccess(TRANSLATION_KEYS_LARGE_FORMAT.fieldLabel, {
      isRetail,
      isDistributor,
    })
  }

  return getTranslationByPartnerAccess(TRANSLATION_KEYS.fieldLabel, {
    isRetail,
    isDistributor,
  })
}
